import {createRouter, createWebHistory} from 'vue-router'
import {isPathMatch} from "@/utils/paramsUtils";
import {getToken} from "@/utils/auth";
import bus from "@/plugins/bus"

const routes = [
    {
        path: '/',
        name: 'Home',
        alias: ['/index', '/home'],
        component: () => import('@/views/Home.vue'),
        meta: {
            title: '江西创意文化活动服务平台'
        }
    },
    {
        path: '/task',
        name: 'TaskIndex',
        component: () => import('@/views/task/TaskIndex.vue'),
        meta: {
            title: '任务大厅'
        },
    },
    {
        path: '/taskPub',
        name: 'TaskPublic',
        component: () => import('@/views/task/TaskPublic.vue'),
        meta: {
            title: '任务发布'
        }
    },
    {
        path: '/taskPubRes',
        name: 'TaskPubRes',
        component: () => import('@/views/task/TaskPubRes.vue'),
        meta: {
            title: '任务发布结果'
        }
    },
    {
        path: '/taskHallDetail',
        name: 'TaskHallDetail',
        component: () => import('@/views/task/TaskHallDetail.vue'),
        meta: {
            title: '任务详情'
        }
    },


    {
        path: '/service',
        name: 'ServiceProvider',
        component: () => import('@/views/service/ServiceProvider.vue'),
        meta: {
            title: '服务商'
        }
    }, {
        path: '/servicerInfo',
        name: 'ServicerDetail',
        component: () => import('@/views/service/ServicerDetail.vue'),
        meta: {
            title: '服务商信息'
        }
    },
    {
        path: '/cases',
        name: 'CasesIndex',
        component: () => import('@/views/cases/CasesIndex.vue'),
        meta: {
            title: '案例中心'
        }
    },
    {
        path: '/cases/detail',
        name: 'CasesDetail',
        component: () => import('@/views/cases/CaseDetail.vue'),
        meta: {
            title: '案例中心-案例详情'
        }
    },
    {
        path: '/ServicerCertification',
        name: 'ServicerCertification',
        component: () => import('@/views/service/ServicerCertification.vue'),
        meta: {
            title: '服务商入驻'
        }
    },
    {
        path: '/ServiceCertUpdate',
        name: 'ServiceCertUpdate',
        component: () => import('@/views/service/ServiceCertUpdate.vue'),
        meta: {
            title: '服务商入驻-重新提交'
        }
    },


    //     账户设置
    {
        path: '/mine',
        name: 'MineInfo',
        component: () => import('@/views/info/MyInfoIndex.vue'),
        meta: {
            title: '账户设置'
        },
        children: [
            {
                path: '/mine/center',
                name: 'MyInfoCenter',
                component: () => import('@/views/info/MyInfoCenter.vue'),
                meta: {
                    title: '账户中心-个人中心'
                }
            },
            {
                path: '/mine/phoneCertification',
                name: 'phoneCertification',
                component: () => import('@/views/info/certification/phoneCertification.vue'),
                meta: {
                    title: '账户设置-手机号认证'
                }
            },
            {
                path: '/mine/emailCertification',
                name: 'emailCertification',
                component: () => import('@/views/info/certification/emailCertification.vue'),
                meta: {
                    title: '账户设置-邮箱认证'
                }
            }, {
                path: '/mine/loginPwdUpdate',
                name: 'loginPwdUpdate',
                component: () => import('@/views/info/password/loginPwdUpdate.vue'),
                meta: {
                    title: '账户设置-登录密码修改认证'
                }
            },
            {
                path: '/mine/operationPwdUpdate',
                name: 'operationPwdUpdate',
                component: () => import('@/views/info/password/operationPwdUpdate.vue'),
                meta: {
                    title: '账户设置-操作密码修改认证'
                }
            },
            {
                path: '/mine/serviceCert',
                name: 'serviceCertification',
                component: () => import('@/views/info/certification/serviceCertification.vue'),
                meta: {
                    title: '账户设置-服务商认证'
                }
            },
        ]
    },
    //财务中心
    {
        path: '/finance',
        name: 'FinanceIndex',
        component: () => import('@/views/finance/MyFinanceIndex.vue'),
        meta: {
            title: '财务中心'
        },
        children: [
            {
                path: '/finance/mine',
                name: 'FinanceMineInfo',
                component: () => import('@/views/finance/MyFinanceCenter.vue'),
                meta: {
                    title: '财务中心-个人中心'
                }
            }, {
                path: '/finance/myBankCard',
                name: 'MyBankCard',
                component: () => import('@/views/finance/withdraw/bankCard/MyBankCard.vue'),
                meta: {
                    title: '财务中心-我的银行卡'
                }
            }, {
                path: '/finance/withdrawRecord',
                name: 'withdrawRecord',
                component: () => import('@/views/finance/withdraw/fundWithdraw/withdrawRecord.vue'),
                meta: {
                    title: '财务中心-提现明细'
                }
            }, {
                path: '/finance/withdrwaApply',
                name: 'withdrwaApply',
                component: () => import('@/views/finance/withdraw/fundWithdraw/withdrwaApply.vue'),
                meta: {
                    title: '财务中心-资金提现'
                }
            },
            {
                path: '/finance/transactionRecord',
                name: 'TransactionRecord',
                component: () => import('@/views/finance/transaction/TransactionRecord.vue'),
                meta: {
                    title: '财务中心-资金流水'
                }
            }, {
                path: '/finance/FreezeRecord',
                name: 'FreezeRecord',
                component: () => import('@/views/finance/transaction/FreezeRecord.vue'),
                meta: {
                    title: '财务中心-资金冻结记录'
                }
            }, {
                path: '/finance/account',
                name: 'FinanceAccount',
                component: () => import('@/views/finance/account/financeAccount.vue'),
                meta: {
                    title: '财务中心-服务商账户'
                }
            }, {
                path: '/finance/bocoBook',
                name: 'BocoBook',
                component: () => import('@/views/finance/account/bocoBook.vue'),
                meta: {
                    title: '财务中心-服务商账户'
                }
            }
        ]
    },


    //我的任务
    {
        path: '/taskCenter',
        name: 'MineTaskIndex',
        component: () => import('@/views/myTask/MyTaskIndex.vue'),
        meta: {
            title: '任务中心'
        },
        children: [
            {
                path: '/taskCenter/mine',
                name: 'MyTaskCenter',
                component: () => import('@/views/myTask/MyTaskCenter.vue'),
                meta: {
                    title: '任务中心-我的发布'
                }
            },
            {
                path: '/taskCenter/myPubTask',
                name: 'MyPubTask',
                component: () => import('@/views/myTask/myPubTask/MyPubTask.vue'),
                meta: {
                    title: '任务中心-我的发布'
                }
            },
            {
                path: '/taskCenter/myDraftTask',
                name: 'MyDraftTask',
                component: () => import('@/views/myTask/myDraftTask/MyTaskDraft.vue'),
                meta: {
                    title: '任务中心-任务草稿'
                }
            }, {
                path: '/taskCenter/myDealTask',
                name: 'MyDealTask',
                component: () => import('@/views/myTask/myDeal/MyDeallTask.vue'),
                meta: {
                    title: '任务中心-任务草稿'
                }
            },
            {
                path: '/taskCenter/myCollectionTask',
                name: 'MyCollectionTask',
                component: () => import('@/views/myTask/myCollection/MyCollectionTask.vue'),
                meta: {
                    title: '任务中心-我的收藏'
                }
            }, {
                path: '/taskCenter/taskViewHistory',
                name: 'MyTaskViewHistory',
                component: () => import('@/views/myTask/myViewHistory/MyTaskViewHistory.vue'),
                meta: {
                    title: '任务中心-历史足迹'
                }
            }, {
                path: '/taskCenter/taskSignUpList',
                name: 'MySignUpTask',
                component: () => import('@/views/myTask/mySignUp/MySignUpTask.vue'),
                meta: {
                    title: '任务中心-报名列表'
                }
            },
            {
                path: '/taskCenter/fastTask',
                name: 'MyFastTask',
                component: () => import('@/views/myTask/myFastTask/index.vue'),
                meta: {
                    title: '任务中心-快速发布'
                }
            }
        ]
    },


    {
        path: '/news',
        name: 'NewsCenter',
        component: () => import('@/views/news/NewsIndex.vue'),
        meta: {
            title: '资讯中心'
        }
    },
    {
        path: '/news/detail',
        name: 'NewsDetail',
        component: () => import('@/views/news/NewsDetail.vue'),
        meta: {
            title: '资讯中心-资讯详情'
        }
    }

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    mode: 'hash',
    routes
})

//路由白名单
const whiteList = ['/', '/index', '/home', '/task', '/service', '/404', '/news'];

const isWhiteList = (path) => {
    return whiteList.some(pattern => isPathMatch(pattern, path));
};


// 路由守卫 - 动态设置页面标题
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = '工会文化服务平台'; // 默认标题
    }
    //路由白名单直接放行
    if (isWhiteList(to.path)) {
        next();
    } else {
        //非路由白名单
        let token = getToken();
        if (token && token !== '' && token !== 'undefined') {
            next();
        } else {
            //唤起登录弹窗
            bus.emit('loginModal:open')
        }
    }
});

export default router
